import { Children } from 'react';
import { IProductOptions } from './productOptions.models';
import Option from './components/Option/option';

const ProductOptions = ({
  inflactions,
  productId,
  productPrice,
  productName,
  productCategory,
}: IProductOptions) => {
  if (!inflactions || inflactions?.length === 0) return null;
  if (inflactions && inflactions?.length > 0 && !inflactions?.some((e) => e.text)) return null;
  return (
    <div>
      {Children.toArray(
        inflactions?.map(
          (inflation) =>
            (inflation?.text || inflation.disclaimer) && (
              <Option
                optionTitle={inflation?.text}
                popupTitle={inflation?.titlePopup}
                popup={inflation?.popup}
                color={inflation?.color}
                optionDisclaimer={inflation?.disclaimer}
                isGlobalPromo={inflation?.isGlobalPromo}
                productId={productId}
                productName={productName}
                productCategory={productCategory}
                productPrice={productPrice}
              />
            )
        )
      )}
    </div>
  );
};

export default ProductOptions;
